import { gql } from '@apollo/client';

export const GENERATE_DOCU_SIGN_ENVELOPE = gql`
  mutation Flex_GenerateDocuSignEnvelope($input: DocuSignEnvelopeCreateInput!) {
    generateDocuSignEnvelope(input: $input)
  }
`;
